/**
 * Detect if browser is in private/incognito mode
 * @returns {Promise<boolean>}
 */
export async function isPrivateMode() {
    // Check for common indicators of private mode
    try {
        // Method 1: Check if Service Workers are available
        if (!('serviceWorker' in navigator)) {
            return true
        }

        // Method 2: Try to access indexedDB
        if (!window.indexedDB) {
            return true
        }

        // Method 3: Try to open a test database
        return new Promise((resolve) => {
            const testKey = 'privateModeTest'

            try {
                // Try localStorage (restricted in some private modes)
                localStorage.setItem(testKey, '1')
                localStorage.removeItem(testKey)

                // Try to open IndexedDB
                const request = indexedDB.open('privateModeTest')

                request.onsuccess = () => {
                    indexedDB.deleteDatabase('privateModeTest')
                    resolve(false) // Not private mode
                }

                request.onerror = () => {
                    resolve(true) // Likely private mode
                }
            } catch (e) {
                resolve(true) // Error accessing storage = private mode
            }
        })
    } catch (error) {
        // If any error, assume private mode for safety
        return true
    }
}

/**
 * Check if browser is in private mode (synchronous check)
 * @returns {boolean}
 */
export function isPrivateModeSync() {
    try {
        // Quick checks that work synchronously
        if (!('serviceWorker' in navigator)) {
            return true
        }

        if (!window.indexedDB) {
            return true
        }

        // Try localStorage
        const testKey = '__privateTest__'
        try {
            localStorage.setItem(testKey, '1')
            localStorage.removeItem(testKey)
        } catch (e) {
            return true
        }

        return false
    } catch (error) {
        return true
    }
}
